// Emoji puzzles ("Which movie is this? 🦁👑") are ordinary multiple-choice questions whose prompt ends in emoji.
// Everything that draws a prompt (the app, the question page, the video) shows that emoji run big on its own line,
// and everything that can't draw emoji (the share card's picture renderer) asks for the text part only.
// Pure, so every surface splits the same way.
// Pictographs, flags (regional indicators), joiners, variation selectors and the spaces between them.
const EMOJI_TAIL = /^(.*?)\s*((?:\p{Extended_Pictographic}|\p{Regional_Indicator}|[‍️\u{1f3fb}-\u{1f3ff}])(?:\p{Extended_Pictographic}|\p{Regional_Indicator}|[‍️\u{1f3fb}-\u{1f3ff}\s])*)$/su;
/** Splits a prompt that ends in an emoji run; null for an ordinary prompt (or one that is only emoji). */
export function splitEmojiPrompt(prompt) {
    const m = EMOJI_TAIL.exec(prompt.trim());
    if (!m)
        return null;
    const lead = m[1].trim();
    const emoji = m[2].trim();
    return lead && emoji ? { lead, emoji } : null;
}
/** True when the prompt ends in emoji (the intake check lets such a prompt end without a question mark). */
export const endsInEmoji = (prompt) => splitEmojiPrompt(prompt) !== null;
/** The prompt for a surface with no emoji font: the words only, plus a nudge to look at the real thing. */
export function promptWithoutEmoji(prompt) {
    const parts = splitEmojiPrompt(prompt);
    return parts ? `${parts.lead} (an emoji puzzle: open it to see the emoji)` : prompt;
}
